"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames_1 = require("classnames");
var utils_1 = require("../utils");
var getCSSSize = function (width) { return ({
    width: !isNaN(width) ? utils_1.toREMString(width) : "auto"
}); };
exports.default = (function (_a) {
    var theme = _a.theme, className = _a.className, blue = _a.blue, gray = _a.gray, white = _a.white, _b = _a.size, size = _b === void 0 ? 2 : _b;
    var _c;
    return (React.createElement("div", { className: classnames_1.default(theme.circle, className, (_c = {},
            _c[theme.blue] = blue,
            _c[theme.gray] = gray,
            _c[theme.white] = white,
            _c)), style: getCSSSize(size) },
        React.createElement("svg", { className: theme.circular, viewBox: "25 25 50 50" },
            React.createElement("circle", { className: theme.path, cx: "50", cy: "50", r: "20", fill: "none", strokeMiterlimit: "10" }))));
});
